import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Apiurl from "../../Helpers/apiUrl";
import { handleApiError } from "../../Helpers/handleApiError ";
import Swal from "sweetalert2";

const getToken = () => localStorage.getItem("u_token");

export const fetchHelpdesk = createAsyncThunk(
  "helpdesk/fetchHelpdesk",
  async ({ search, page, rowsPerPage, month, year,sort_by,sort_order }, { rejectWithValue }) => {
    const token = getToken();
    if (!token)
      return rejectWithValue({
        message: "No token found, authorization failed.",
      });

    try {
      const response = await axios.get(`${Apiurl}admin/userlist/help/desk/list`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          search,
          page: page + 1,
          limit: rowsPerPage,
          sort_by,
          sort_order,
          month,
          year,
        }
      });

      return response.data;
    } catch (error) {
      handleApiError(error, "Please try again later.");
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch helpdesks." }
      );
    }
  }
);

const initialState = {
  helpdeskData: [],
  helpdeskDetail: [],
  count: 0,
  loading: false,
  status: "idle",
  deleteStatus: "idle",
  error: null,
};

const helpdeskSlice = createSlice({
  name: "helpdesk",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchHelpdesk.pending, (state) => {
        state.error = null;
        state.status = "pending";
      })
      .addCase(fetchHelpdesk.fulfilled, (state, action) => {
        state.helpdeskData = action.payload.data;
        state.count = action.payload.total;
       state.status = "succeeded";
      })
      .addCase(fetchHelpdesk.rejected, (state, action) => {
        state.error = action.payload;
        state.status = "failed";
      });
  },
});

export default helpdeskSlice.reducer;
